import * as React from 'react';
import { BanksListContainer } from '../../containers/BanksListContainer';
import { ShowcaseWall } from '../../components/ShowcaseWall';
import { SubmitPhoneFormContainer } from '../../containers/SubmitPhoneFormContainer';
import { Notes } from '../../components/Notes';
import { QuickLinks } from '../../MarketingPageComponents/QuickLinks';
import { FinCalculator } from '../../MarketingPageComponents/FinCalculator';
import { MortgageVideo } from '../../MarketingPageComponents/MortgageVideo';
import { SecondBlockForm } from '../../components/SecondBlockForm';

import * as styles from './styles.css';
import { AdvantagesMediaContainer } from '../../containers/AdvantagesMediaContainer/AdvantagesMediaContainer';

export const MediaPage = () => {
  return (
    <div className={styles['marketing-page']}>
      <SubmitPhoneFormContainer Form={ShowcaseWall} formTitle="Заполним анкету на ипотеку?" label="main_login_block" />
      <BanksListContainer />
      <MortgageVideo />
      <AdvantagesMediaContainer />
      <FinCalculator />
      <SubmitPhoneFormContainer Form={SecondBlockForm} label="second_login_block" />
      <QuickLinks />
      <Notes />
    </div>
  );
};
